import React, { useState, useRef } from "react";
import styles from "./Feedback.module.scss";
import Comment from "../../components/icons/Comment";
import Cancel from "../../components/icons/Cancel";
import Axios from "axios";
import Loading from "../../components/Loading/Loading";
import Informer from "../../components/Informer/Informer";
import Cleaning from "../../components/icons/Cleaning";
import Success from "../../components/icons/Success";
import TagManager from "react-gtm-module";
import { useTranslation } from "react-i18next";

export type FeedbackProps = {
  close: () => void;
};

export type FormStatus = "Edit" | "Sending" | "Success" | "Error";
// eslint-disable-next-line
const Feedback: React.FC<FeedbackProps> = ({ close }) => {
  const { t } = useTranslation();
  const [formStatus, setFormStatus] = useState<FormStatus>("Edit");
  const [sendDisabled, setSendDisabled] = useState(true);
  const refFeedbackContent = useRef(null);
  const isFieldValid = (event: any) => {
    setSendDisabled(event.target.value === "");
  };

  const sendEventToGoogleAnalytics = () => {
    let pageLocation = "";
    const url = window.location.href;
    if (!url.includes("code") && !url.includes("electrification") && !url.includes("domain")) {
      pageLocation = "main_page";
      // eslint-disable-next-line
    } else if (url.match(new RegExp('/[0-9]+/'))) { 
      pageLocation = "details_view";
    } else {
      pageLocation = "list_view";
    }
    // Set GA tag
    TagManager.dataLayer({
      dataLayer: {
        event: "feedback",
        feedback_location: pageLocation
      }
    });
  };

  const mailtoFeedback = (feedback: any) => {
    const subject = "Feedback for FaultViewerWeb";
    const toEmail = "ServiceToolsSupport@kone.com";
    let body = "Feedback:%0D%0A %0D%0A";

    body += feedback.replace(/(?:\r\n|\r|\n)/g, "%0D%0A");
    body += "%0D%0A-------------------------------------------------";
    window.location.href = `mailto:${toEmail}?subject=${subject}&body=${body}`;
  };
  /** Sending feedback through SMTP server mailer is not used atm, but kept in case it will be */
  const sendFeedback = async (feedback: string) => {
    setFormStatus("Sending");
    try {
      await Axios.post("http://localhost", { feedback: feedback }); // Add server endpoint here
      setFormStatus("Success");
      setTimeout(() => close(), 3000);
    } catch (e) {
      setFormStatus("Error");

      console.log(e);
    }
  };

  const handleSendFeedbackButton = () => {
    // @ts-ignore
    const feedback = refFeedbackContent.current.value;
    sendEventToGoogleAnalytics();
    mailtoFeedback(feedback);
    close();
  };
  const contentSwitcher = () => {
    switch (formStatus) {
      case "Edit":
        return (
          <>
            <div className={styles.headerRow}>
              <div className={styles.Header}>
                <h1>{t("send_us_feedback")}</h1>
                <Comment height="48px" />
              </div>
              <div className={styles.Cancel} onClick={() => close()}>
                <Cancel />
              </div>
            </div>
            <div className={styles.info}>
              <p>{t("feedback_body")}</p>
            </div>

            <textarea
              ref={refFeedbackContent}
              style={{ height: "300px" }}
              name="feedback_content"
              onChange={event => isFieldValid(event)}
              placeholder={t("type_feedback_here")}
              className={styles.textsarea}
            />
            <button disabled={sendDisabled} onClick={handleSendFeedbackButton}>
              {t("send")}
            </button>
          </>
        );
      case "Sending":
        return (
          <>
            <div className={styles.Cancel} onClick={() => close()}>
              <Cancel />
            </div>
            <div className={styles.Center}>
              <Loading text={t("sending_feedback")} />;{" "}
            </div>
          </>
        );
      case "Success":
        return (
          <>
            <div className={styles.Cancel} onClick={() => close()}>
              <Cancel />
            </div>
            <div className={styles.Center}>
              <Informer
                icon={<Success height="116px" />}
                title={t("thank_you")}
                text={t("feedback_sent")}
              />
            </div>
          </>
        );
      case "Error":
        return (
          <>
            <div className={styles.Cancel} onClick={() => close()}>
              <Cancel />
            </div>
            <div className={styles.Center}>
              <Informer
                icon={<Cleaning height="94px" />}
                title={t("feedback_not_send_title")}
                text={t("feedback_not_sent")}
                button={{ text: "TRY AGAIN", callback: sendFeedback }}
              />
            </div>
          </>
        );

      default:
        return <div>UnKnown Error</div>;
    }
  };

  return <div className={styles.FeedbackOpen}>{contentSwitcher()}</div>;
};

export default Feedback;
